import { render, staticRenderFns } from "./ProjectSpecifics.vue?vue&type=template&id=1ca0d8d2&scoped=true&"
import script from "./ProjectSpecifics.vue?vue&type=script&lang=js&"
export * from "./ProjectSpecifics.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSpecifics.vue?vue&type=style&index=0&id=1ca0d8d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca0d8d2",
  null
  
)

export default component.exports